export const BackTop = () => {
    return (
        <a href="#blocktop" id="backtop" className="backtop hide">
            <i className="fa fa-arrow-up"></i>
        </a>
    )
}